import React from "react";
import "./Expert.css";
const Expert = () => {
  return (
    <div id="expert" className=" relative py-[50px] items-start custom-class">
      <div className="flex flex-col px-10  items-start w-full sm:w-[80%] lg:w-[40%] gap-10 ">
        <h1 className="text-white font-bold leading-[26px] sm:leading-[50px] text-lg sm:text-3xl  font-sans ">
          Looking for a step-change in your business’ technology capabilities?
        </h1>
        <p className="text-white text-lg font-serif font-semibold">
          We’ll lead you there.
        </p>
        <button className="text-white cursor-pointer border-[1px] border-white duration-300 hover:scale-110 hover:text-[#4f1951] hover:border-[#4f1951] px-5 py-2  rounded-lg  self-start hover:bg-white">
          Talk to an Expert
        </button>
      </div>
    </div>
  );
};

export default Expert;
